'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wordSpacing = exports.whiteSpace = exports.unicodeBidi = exports.textOverflow = exports.textTransform = exports.textShadow = exports.textIndent = exports.textDecoration = exports.textAlign = exports.letterSpacing = exports.lineHeight = exports.direction = exports.color = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', ';\n  '], ['\n    ', ';\n  ']);

var _core = require('@emotion/core');

var _ = require('../../');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var color = exports.color = function color(_ref) {
  var color = _ref.color;
  return color && (0, _core.css)(_templateObject, _2.default.responsive('color')(color));
};

var direction = exports.direction = function direction(_ref2) {
  var direction = _ref2.direction;
  return direction && (0, _core.css)(_templateObject, _2.default.responsive('direction')(direction));
};

var lineHeight = exports.lineHeight = function lineHeight(_ref3) {
  var lineHeight = _ref3.lineHeight;
  return lineHeight && (0, _core.css)(_templateObject, _2.default.responsive('line-height')(lineHeight));
};

var letterSpacing = exports.letterSpacing = function letterSpacing(_ref4) {
  var letterSpacing = _ref4.letterSpacing;
  return letterSpacing && (0, _core.css)(_templateObject, _2.default.responsive('letter-spacing')(letterSpacing));
};

var textAlign = exports.textAlign = function textAlign(_ref5) {
  var textAlign = _ref5.textAlign;
  return textAlign && (0, _core.css)(_templateObject, _2.default.responsive('text-align')(textAlign));
};

var textDecoration = exports.textDecoration = function textDecoration(_ref6) {
  var textDecoration = _ref6.textDecoration;
  return textDecoration && (0, _core.css)(_templateObject, _2.default.responsive('text-decoration')(textDecoration));
};

var textIndent = exports.textIndent = function textIndent(_ref7) {
  var textIndent = _ref7.textIndent;
  return textIndent && (0, _core.css)(_templateObject, _2.default.responsive('text-indent')(textIndent));
};

var textShadow = exports.textShadow = function textShadow(_ref8) {
  var textShadow = _ref8.textShadow;
  return textShadow && (0, _core.css)(_templateObject, _2.default.responsive('text-shadow')(textShadow));
};

var textTransform = exports.textTransform = function textTransform(_ref9) {
  var textTransform = _ref9.textTransform;
  return textTransform && (0, _core.css)(_templateObject, _2.default.responsive('text-transform')(textTransform));
};

var textOverflow = exports.textOverflow = function textOverflow(_ref10) {
  var textOverflow = _ref10.textOverflow;
  return textOverflow && (0, _core.css)(_templateObject, _2.default.responsive('text-overflow')(textOverflow));
};

var unicodeBidi = exports.unicodeBidi = function unicodeBidi(_ref11) {
  var unicodeBidi = _ref11.unicodeBidi;
  return unicodeBidi && (0, _core.css)(_templateObject, _2.default.responsive('unicode-bidi')(unicodeBidi));
};

var whiteSpace = exports.whiteSpace = function whiteSpace(_ref12) {
  var whiteSpace = _ref12.whiteSpace;
  return whiteSpace && (0, _core.css)(_templateObject, _2.default.responsive('white-space')(whiteSpace));
};

var wordSpacing = exports.wordSpacing = function wordSpacing(_ref13) {
  var wordSpacing = _ref13.wordSpacing;
  return wordSpacing && (0, _core.css)(_templateObject, _2.default.responsive('word-spacing')(wordSpacing));
};